<template>
  <XButton :class="['create-btn dark']" type="primary" @click="handleCreateWork">
    {{ $t('kai-qi-chuang-zuo') }}
  </XButton>
</template>

<script lang="ts" setup>
import XButton from '~/design/atom/button.vue';

const handleCreateWork = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    loginTask.add({
      type: IAfterLoginActionType.CREATE_WORK,
      payload: {},
    });
    navigateTo(`/login?redirect=${encodeURIComponent(encodeURIComponent(location.href))}`);
  } else {
    if (process.env.NODE_ENV === 'development') {
      location.href = `//localhost:8888`;
    } else {
      location.href = `${location.origin}/workspace`;
    }
  }
};
</script>

<style lang="scss" scoped>
.create-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 36px;
  padding: 0px 24px;
  min-width: 112px;
  border-radius: 8px;
  font-size: 16px;

  &:hover {
    background: var(--purple-6);
    border: 1px solid var(--purple-6);
    color: #fff;
  }

  &.dark {
    background: var(--purple-6);
    border: 1px solid var(--purple-6);
    color: #fff;
    &:hover {
      color: #fff;
      background-color: #524cc8;
      border: 1px solid transparent;
    }
  }
}
</style>
